module.exports = __webpack_public_path__ + "static/img/img-main-award@3x.eb61250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-award@3x.png
// module id = j+fc
// module chunks = 18